import React from 'react';
import { TableCell, TableHead, TableRow } from '@mui/material';
import Title from '../../../../components/Title';
import useTranslate from '../../../../../customHooks/useTranslate';
import Icon from '../../../../../muiComponents/Icon';

interface MembersTableSectionHeaderProps {
    name: string;
    isOpen: boolean;
    handleToggle: () => void;
}
const MembersTableSectionHeader = (props: MembersTableSectionHeaderProps) => {
    const { name, isOpen, handleToggle } = props;
    const translate = useTranslate();

    return (
        <TableHead>
            <TableCell colSpan={4} sx={{ border: 0 }}>
                <div className='flex flex-align-end flex-between margin-top10'>
                    <Title className='text-size-20'>{name}</Title>
                    <Icon
                        iconName={
                            isOpen ? 'KeyboardArrowUp' : 'KeyboardArrowDown'
                        }
                        className='cursor-pointer'
                        onClick={handleToggle}
                    />
                </div>
            </TableCell>
            {isOpen ? (
                <TableRow>
                    <TableCell className='text-capitalize'>
                        {translate('connected')}
                    </TableCell>
                    <TableCell className='text-capitalize'>
                        {translate('name')}
                    </TableCell>
                    <TableCell className='text-capitalize'>
                        {translate('country')}
                    </TableCell>
                    <TableCell className='text-capitalize'></TableCell>
                </TableRow>
            ) : (
                ''
            )}
        </TableHead>
    );
};

export default MembersTableSectionHeader;
